import { MatDialog } from '@angular/material/dialog';
import { ContactUsPopupComponent } from '@components/contact-us-popup/contact-us-popup.component';
import { PrivacyPopupComponent } from '@components/privacy-popup/privacy-popup.component';
import { TermsPopupComponent } from '@components/terms-popup/terms-popup.component';
import * as i0 from "@angular/core";
import * as i1 from "@angular/material/dialog";
var CommonDialogService = /** @class */ (function () {
    function CommonDialogService(dialog) {
        this.dialog = dialog;
    }
    CommonDialogService.prototype.showTerms = function () {
        this.dialog.open(TermsPopupComponent, { width: '80%' });
    };
    CommonDialogService.prototype.showPrivacy = function () {
        this.dialog.open(PrivacyPopupComponent, { width: '80%' });
    };
    CommonDialogService.prototype.showContact = function () {
        this.dialog.open(ContactUsPopupComponent);
    };
    CommonDialogService.ngInjectableDef = i0.defineInjectable({ factory: function CommonDialogService_Factory() { return new CommonDialogService(i0.inject(i1.MatDialog)); }, token: CommonDialogService, providedIn: "root" });
    return CommonDialogService;
}());
export { CommonDialogService };
